<template>
    <v-tooltip v-if="approved" bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-icon color="success" dark v-bind="attrs" v-on="on">
                mdi-check
            </v-icon>
        </template>
        <span>Approved</span>
    </v-tooltip>
    <v-tooltip v-else bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-icon color="warning" dark v-bind="attrs" v-on="on">
                mdi-alert
            </v-icon>
        </template>
        <span>Not Approved</span>
    </v-tooltip>
</template>
<script>
export default {
    name: 'ApprovalStatusIcon',
    props: {
        status: {
            type: Number,
            required: true,
        },
    },
    computed: {
        approved() {
            return this.status === 3
        },
    },
}
</script>
